<template>
    <div class="outer-content">
        <div class="inner-content" v-if="playGame">

            <div class="upper-panel">
                <div class="header" v-html="T('Enter_Session_Code')"></div>
            </div>

            <div class="rectangle-container position-relative w-100 d-flex justify-content-center align-items-center">
                <div class="rectangle d-flex justify-content-center align-items-center">
                    <input v-model="pin" type="number" @input="fixInput(pin)" />
                    <span v-if="!pin" class="asterisk-holder">****</span>
                </div>
            </div>

            <TuiError :msg="joinError">
            </TuiError>

            <div class="button-container w-100 d-flex justify-content-center align-items-center">
                <StartButton @click="$emit('start-game', pin)">
                </StartButton>
            </div>

            <div class="shared-back-button" v-html="T('button_back')" @click="$emit('back')">
            </div>            

        </div>
    </div>
</template>

<script lang="ts">
import { T } from '@/App.vue';
import Vue from 'vue';
import StartButton from '../components/Simple/StartButton.vue';
import TuiError from "../components/TuiError.vue"

export default Vue.extend({
    name: 'JoinSession',
    components: {
        StartButton,
        TuiError
    },
    props: {
        joinError: String,
        playGame: Boolean,
    },
    data() {
        return {
            pin: "",
        };
    },
    methods: {
        T(key: string): string {
            return T(key);
        },
        fixInput(value: string) {

            if (value.indexOf("=") > -1) {
                const values = value.split("=");
                value = values[values.length - 1];
            }

            this.pin = value.slice(0, 4);
        }
    }
});
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
input {
    border: 0;
    width: 100%;
    height: 100%;
    text-align: center;
    color: #9A9A9A;
    font-family: Rubik;
    font-size: 150px;
    font-weight: 900;
    letter-spacing: 0;
    line-height: normal;
    text-align: center;
    overflow: hidden;
    background: none;
    padding: 0;
}

.asterisk-holder {
    position: absolute;
    border: 0;
    width: 100%;
    Height: 100%;
    text-align: center;
    color: #9A9A9A;
    font-family: Rubik;
    font-size: 180px;
    font-weight: 900;
    letter-spacing: 0;
    line-height: 213px;
    text-align: center;
    overflow: hidden;
    background: none;
    padding: 0;
    pointer-events: none;
    margin-top: 63px;
}

textarea:focus,
input:focus {
    outline: none;
}

::placeholder {
    color: #9A9A9A;
}

/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
}

/* Firefox */
input[type=number] {
    -moz-appearance: textfield;
}

.rectangle-container {
    margin-bottom: 50px;
}

.copy-code-container {
    top: 522px;
    color: #636252;
    font-family: Rubik;
    font-size: 38px;
    font-weight: bold;
    letter-spacing: 0;
    line-height: 46px;
    text-align: center;
}

.copy-code-button {
    pointer-events: unset;
    cursor: pointer;
}

.rectangle {
    box-sizing: border-box;
    height: 195px;
    width: 840px;
    border: 12px solid #4A4A4A;
    border-radius: 32px;
    background-color: #FFFFFF;
    display: flex;
    justify-content: center;
    align-items: center;
}
</style>
